/*****************************************************************************************/
// CLOSE CART DRAWER
// When AJAX cart request starts (optimistic update)
document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  if (event.detail && event.detail.cart) {
    // refreshCartCount(event.detail.cart);
  }

  const { requestState } = event.detail;
  if (requestState.requestType === "add" && requestState.responseData?.ok) {
    document.querySelector("body").classList.add("js-ajax-cart-open");
  }
  updateLoyaltyPointsFromCart();

});

function refreshCartCount(cart) {
  console.log('testertester')
  const count = cart.item_count || 0;
  console.log('custom-cart', count)
  const cartCountEl = document.querySelector('#cart-svg-count');
  const cartIconWrapper = document.querySelector('.cart-wrapper');

  // Update text
  cartCountEl.textContent = count;
  cartCountEl.dataset.cartCount = count;
  // Toggle visibility classes
  if (count > 0) {
    cartCountEl.classList.add('cart-show');
    cartIconWrapper.classList.add('cart-show');
    if (count > 9) cartCountEl.classList.add('cart-extra-pad');
    else cartCountEl.classList.remove('cart-extra-pad');
  } else {
    cartCountEl.classList.remove('cart-show');
    cartIconWrapper.classList.remove('cart-show');
  }
  console.log('Cart count updated:', count);
}


function runWhenInit() {
  console.log("The current cart state is: ", window.liquidAjaxCart.cart);
}

if (window.liquidAjaxCart?.init) {
  runWhenInit();
} else {
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

/*****************************************************************************************/
// Format to Euro
function formatToGermanMoney(price) {
  const adjustedPrice = price / 100;
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(adjustedPrice);
}

/*****************************************************************************************/
// Loyalty Points: Fetch from /cart.js and update DOM
function updateLoyaltyPointsFromCart() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const euros = cart.total_price / 100;
      const points = Math.floor(euros) * 2;

      const pointsElem = document.querySelector("#cart-points-message");
      if (pointsElem) {
        const label = pointsElem.dataset.label || "Punkte";
        pointsElem.textContent = `${points} ${label}`;
      }
    })
    .catch((err) => console.error("Failed to update Treuepunkte:", err));
}

// Watch cart drawer DOM changes (add/remove/update)
function observeCartDrawerForChanges() {
  const cartDrawer = document.querySelector(".js-ajax-cart-open");

  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    updateLoyaltyPointsFromCart();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}

/*****************************************************************************************/
// UPSELL MODAL LOGIC
document.addEventListener("click", function (event) {
  if (event.target.classList.contains("openUpsell")) {
    event.preventDefault();
    handleUpsellClick(event.target);
  }
  if (event.target.classList.contains("MyCartUpsells_CloseModal")) {
    closeUpsellModal();
  }
  if (event.target.classList.contains("MyCartUpsells_AddToCart")) {
    event.preventDefault();
    addUpsellToCart();
  }
});

function handleUpsellClick(button) {
  const imageUrl = button.dataset.imageUrl;
  const title = button.dataset.title;
  const firstPrice = button.dataset.firstPriceAvailable;
  const comparedPrice = button.dataset.firstComparedPrice;
  const variants = JSON.parse(button.dataset.variants);

  let variantsDropdown = "";
  const shouldShowDropdown =
    variants.length > 1 || variants[0].title !== "Default Title";
  if (variants && variants.length > 0 && shouldShowDropdown) {
    variantsDropdown = `<select id="upsellVariantSelect">`;
    variants.forEach((variant) => {
      const variantImage = variant.featured_image?.src || imageUrl;
      variantsDropdown += `
        <option value="${variant.id}"
        data-image-url="${variantImage}" 
        data-price="${variant.price}" 
        data-compared-price="${variant.compare_at_price}" 
        data-variant-title="${variant.title}">
        ${variant.title}
        </option>`;
    });
    variantsDropdown += `</select>`;
  }

  const modalContent = `
    <div class="MyCartUpsells_ModalOverlay">
      <div class="MyCartUpsells_Modal">
        <button class="MyCartUpsells_CloseModal">&times;</button>
        <div class="MyCartUpsells_Content">
          <img src="${imageUrl}" alt="${title}" class="MyCartUpsells_Image">
          <div class="MyCartUpsells_product-details">
            <h2 class="MyCartUpsells_title">${title}</h2>
            <div class="MyCartUpsells_price MyCartUpsells_sale-price">
              <span id="upsellPrice">${firstPrice}</span>
              ${
                comparedPrice
                  ? `<span class="MyCartUpsells_ComparePrice">${comparedPrice}</span>`
                  : ""
              }
            </div>
            ${variantsDropdown}
            <button class="MyCartUpsells_AddToCart" data-variant-id="${
              variants[0].id
            }">Hinzufügen</button>
          </div> 
        </div>
      </div>
    </div>`;
  document.body.insertAdjacentHTML("beforeend", modalContent);

  const variantSelect = document.getElementById("upsellVariantSelect");
  if (variantSelect) {
    variantSelect.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      document.querySelector(".MyCartUpsells_Image").src =
        selectedOption.dataset.imageUrl;
      document.getElementById("upsellPrice").textContent = formatToGermanMoney(
        selectedOption.dataset.price
      );
      document.querySelector(".MyCartUpsells_ComparePrice").textContent =
        formatToGermanMoney(selectedOption.dataset.comparedPrice);
    });
  }
}

function closeUpsellModal() {
  const modal = document.querySelector(".MyCartUpsells_ModalOverlay");
  if (modal) modal.remove();
}

function addUpsellToCart() {
  const variantSelect = document.getElementById("upsellVariantSelect");
  const variantId = variantSelect
    ? variantSelect.value
    : document.querySelector(".MyCartUpsells_AddToCart").dataset.variantId;
  liquidAjaxCart.add({ id: variantId, quantity: 1 });
  closeUpsellModal();
}

/*****************************************************************************************/
// PRICE + QTY + SUBTOTAL + POINTS
function optimisticPriceUpdate(lineKey, quantity) {
  const input = document.querySelector(`input[data-line-key="${lineKey}"]`);
  if (input) input.value = quantity;

  const wrapper = document.querySelector(`[data-price-wrapper="${lineKey}"]`);
  if (!wrapper) return;

  const unitPrice = parseInt(wrapper.dataset.unitPrice || 0);
  const comparePrice = parseInt(wrapper.dataset.comparePrice || 0);
  const newFinal = unitPrice * quantity;
  const newCompare = comparePrice * quantity;

  let html = `<div class="item-price item-sale-price">${formatToGermanMoney(
    newFinal
  )}</div>`;
  if (comparePrice && newCompare > newFinal) {
    html += `<div class="item-regular-price" style="text-decoration: line-through">${formatToGermanMoney(
      newCompare
    )}</div>`;
  }

  wrapper.innerHTML = html;
}

function optimisticSubtotalUpdate() {
  const inputs = document.querySelectorAll(".ajax-cart-quantity");
  let subtotal = 0;
  let compareTotal = 0;

  inputs.forEach((input) => {
    const qty = parseInt(input.value);
    const unitPrice = parseInt(input.dataset.unitPrice);
    const comparePrice = parseInt(input.dataset.comparePrice || unitPrice);
    const isFree =
      input.closest(".cart-drawer-items")?.dataset?.autoadded === "Yes";

    if (!isNaN(qty) && !isFree) {
      subtotal += qty * unitPrice;
      compareTotal += qty * comparePrice;
    }
  });

  const subtotalElem = document.getElementById("cart-subtotal");
  const discountElem = document.getElementById("cart-discount");

  if (subtotalElem) subtotalElem.textContent = formatToGermanMoney(subtotal);
  if (discountElem) {
    const discount = Math.max(compareTotal - subtotal, 0);
    discountElem.textContent = formatToGermanMoney(discount);
  }

  const pointsElem = document.getElementById("cart-points-message");
  if (pointsElem) {
    const euros = subtotal / 100;
    const points = Math.floor(euros);
    pointsElem.textContent = `${points} Punkte`;
  }
}

/*****************************************************************************************/
// CART QUANTITY UPDATE
function updateCartQuantity(lineKey, quantity) {
  optimisticPriceUpdate(lineKey, quantity);
  optimisticSubtotalUpdate();

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity: quantity }),
  })
    .then(() => fetch("/cart.js"))
    .then((res) => res.json())
    .then(() => {
      optimisticSubtotalUpdate();
      updateLoyaltyPointsFromCart(); // ensure sync
    })
    .catch((err) => console.error("Cart update error:", err));
}

// Quantity Button Handlers
document.addEventListener("click", function (e) {
  const plusBtn = e.target.closest(".ajax-cart-plus");
  const minusBtn = e.target.closest(".ajax-cart-minus");

  if (plusBtn) {
    const key = plusBtn.dataset.lineKey;
    const input = document.querySelector(`input[data-line-key="${key}"]`);
    const qty = parseInt(input.value);
    updateCartQuantity(key, qty + 1);
  }

  if (minusBtn) {
    const key = minusBtn.dataset.lineKey;
    const input = document.querySelector(`input[data-line-key="${key}"]`);
    const qty = parseInt(input.value);
    if (qty > 1) updateCartQuantity(key, qty - 1);
  }
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".ajax-cart-quantity")) {
    const key = e.target.dataset.lineKey;
    const qty = parseInt(e.target.value);
    if (!isNaN(qty) && qty >= 0) updateCartQuantity(key, qty);
  }
});

/*****************************************************************************************/
// FINAL STEP: Trigger loyalty points logic on cart redraws
document.addEventListener("liquid-ajax-cart:cart-request-complete", () => {
  updateLoyaltyPointsFromCart();
  observeCartDrawerForChanges();
});

document.addEventListener("DOMContentLoaded", () => {
  updateLoyaltyPointsFromCart();
  observeCartDrawerForChanges();
});
